import StringUtils from './StringUtils';

export default class GridUtils {
  static parseColumnUpdateFieldInfo(fieldData) {
    const prefix = 'columns[';
    const delimiter = '].';

    if (!StringUtils.isNonEmptyString(fieldData) || !fieldData.startsWith(prefix))
      return null;

    var fragment = fieldData.slice(prefix.length);
    var delimiterIndex = fragment.indexOf(delimiter);

    return {
      columnIndex: parseInt(fragment.slice(0, delimiterIndex), 10),
      dataField: fragment.slice(delimiterIndex + delimiter.length)
    };
  }
}